import axios from "../../utils/axios";

export const deleteConsumerProfile = (traceId) => {
  return axios.delete(`/identities/self/${traceId}`);
};
